import { z } from "zod";
import apiPlacementSchema from "./placementSchema";
import { vector3dSchema } from "./primitivesSchema";

import apiRepresentation2dSchema from "./representation2d/apiRepresentation2dSchema";
import apiRepresentation3dSchema from "./representation3d/apiRepresentation3dSchema";

import apiProductDataSchema from "./productData/apiProductDataSchema";

const apiProductSchema: z.ZodType<any> = z.object({
    globalId: z.string(),
    name: z.string(),
    placement: apiPlacementSchema,
    dimensions: vector3dSchema.optional().nullable(),
    representations2d: z.array(z.lazy(() => apiRepresentation2dSchema.passthrough())),
    representations3d: z.array(z.lazy(() => apiRepresentation3dSchema.passthrough())), 
    productData: apiProductDataSchema.passthrough(),
    children: z.array(z.lazy(() => apiProductSchema)),
  });

export default apiProductSchema;